export default function EmailCircleIcon() {
  return (
    <>
      <path
        d='M36.5 72C56.3823 72 72.5 55.8823 72.5 36C72.5 16.1177 56.3823 0 36.5 0C16.6177 0 0.5 16.1177 0.5 36C0.5 55.8823 16.6177 72 36.5 72Z'
        fill='#FBF3F2'
      />
      <path
        d='M43.1641 24.667H29.8307C25.8307 24.667 23.1641 26.667 23.1641 31.3337V40.667C23.1641 45.3337 25.8307 47.3337 29.8307 47.3337H43.1641C47.1641 47.3337 49.8307 45.3337 49.8307 40.667V31.3337C49.8307 26.667 47.1641 24.667 43.1641 24.667ZM43.7907 32.787L39.6174 36.1203C38.7374 36.827 37.6174 37.1737 36.4974 37.1737C35.3774 37.1737 34.2441 36.827 33.3774 36.1203L29.2041 32.787C28.7774 32.4403 28.7107 31.8003 29.0441 31.3737C29.3907 30.947 30.0174 30.867 30.4441 31.2137L34.6174 34.547C35.6307 35.3603 37.3507 35.3603 38.3641 34.547L42.5374 31.2137C42.9641 30.867 43.6041 30.9337 43.9374 31.3737C44.2841 31.8003 44.2174 32.4403 43.7907 32.787Z'
        fill='#A0383F'
      />
    </>
  );
}
